import { CSSProps } from "@lib/types/generic";
import React, { PropsWithChildren } from "react";

const TableRow = ({ children, ...cssProps }: PropsWithChildren<CSSProps>) => (
  <tr {...cssProps}>{children}</tr>
);

export default TableRow;
